import {
  Maybe,
  ReInspectionStatus,
  ReportAttachmentType,
  ReportSeverity,
  ReportSystemGroupType,
  ReportSystemType,
} from '@inspectify/core';
import React from 'react';

export type ReportAttachmentListType = ReportAttachmentType & {
  label: string;
  displayIndex?: Maybe<number>;
  hasAnchor?: boolean;
}

export type ReportGroupType = ReportSystemGroupType & {
  systems: ReportSystemType[];
};

export enum IssueType {
  fixed = 'fixed',
  still_exists = 'still_exists',
  limitation = 'limitation',
  flag = 'inspectify_flag',
  monitor = 'monitor',
  repair = 'repair',
  safety = 'safety',
}

export type LimitationSummaryRowType = {
  id: string
  systemId: string
  subsystemItem: string
  type: IssueType
  title: string
  reInspectionStatus: ReInspectionStatus | null
  severity?: ReportSeverity
  systemName?: string
  subsystemName?: string
  systemGroupName?: string;
};

export type SowSummaryRowType = {
  id: string;
  systemName: string;
  subsystemName: string;
  description: string;
  unit: string | null;
  status: string;
  isComplete: boolean;
}

export type GroupedDeficienciesBySeverity = {
  [IssueType.safety]: LimitationSummaryRowType[]
  [IssueType.repair]: LimitationSummaryRowType[]
  [IssueType.monitor]: LimitationSummaryRowType[]
  [IssueType.flag]: LimitationSummaryRowType[]
  [IssueType.fixed]: LimitationSummaryRowType[]
};

// DrawerList SectionType

export interface SectionType {
  id: string;
  label: string;
  icon?: JSX.Element;
  path: string;
  extra?: React.ReactNode | React.ReactNode[];
  children?: SectionType[];
}

export enum ClaimStatus {
  NotEstimated = 'not_estimated',
  EstimatedNotStarted = 'estimated_not_started',
  InProgress = 'in_progress',
  Complete = 'complete',
}
